<template>
<div v-if="isLoading" class="opt-content-wrapper pay-pane active px-1 py-5">
    <Spinner class="my-2 animate slideInTop" :color="client_info.colors.app">
        <p v-html="loadingMessage"></p>
    </Spinner>
</div>
<div v-else class="opt-content-wrapper pay-pane active px-1">

    <div v-if="!showCardInput">
        <!--================================ SHOW SAVE CARDS====================== -->
        <SavedCards v-if="!attemptCardRemoval" class="fade" :client_info="client_info" :cards="cards" :redirectToThirdParty="redirectToThirdParty" @handleAttemptCardRemoval="handleAttemptCardRemoval" @callOnePipe="callOnePipe" @triggerCardInput="triggerCardInput" />

        <!--================================ REMOVE CARD CONFIRMATION====================== -->
        <RemoveCard v-else class="fade" :removalMessag="removalMessage" :cardToBeRemoved="cardToBeRemoved" :cards="cards" :client_info="client_info" @cancelCardRemoval="cancelCardRemoval" @removeCard="removeCard" />
    </div>
    <!--================================ SHOW CARD INPUT ========================== -->
    <div v-else>
        <CardInput v-if="!isMpgs" :isLoading="handleIsLoading" :button_color="button_color" />

        <MpgsCardInput v-else :scriptLoaded="scriptLoaded" :redirectToThirdParty="redirectToThirdParty" :extras="provider.extras" @isLoading="handleIsLoading" @callOnePipe="callOnePipe" @triggerPayment="triggerPayment" :button_color="button_color" :mpgsSdkUrl="mpgsSdkUrl" />

    </div>

    <div class="col-12 px-0 mt-4 text-center">
        <a href="javascript:void(0)" class="change-option" @click.prevent="changePaymentOption"> &larr; Choose another method </a>
    </div>
</div>
</template>

<script>
import MpgsCardInput from './includes/MpgsCardInput.vue'
import RemoveCard from './mtn/includes/RemoveCard.vue'
import SavedCards from './includes/SavedCards.vue'
/* eslint-disable */
import axios from 'axios';
import Spinner from './includes/Spinner.vue'
import CardInput from './includes/CardInput.vue'
import {
    TheMask
} from 'vue-the-mask'

export default {
    name: 'CardPayment',
    props: ['appColor', 'data', 'client_info', 'button_color'],
    components: {
        TheMask,
        Spinner,
        CardInput,
        SavedCards,
        RemoveCard,
        MpgsCardInput
    },

    destroyed() {
        if (this.isMpgs) {
            let el = document.querySelector(`script[src='${this.mpgsSdkUrl}']`);
            if (el) {
                el.remove();
            }
        }
    },

    updated() {
        // Look for a way to prevent re initialization
        if (this.isMpgs && !this.isLoading && this.showCardInput) {
            // console.log("Re integrated view again.")
            if (this.showToken && !this.enforce_tokenization) {
                if (this.checkToken)
                    if (document.getElementById('tokenize-card')) {
                        document.getElementById('tokenize-card').checked = true;
                    }
            }
            this.updatedIntegration();
        } else { // know that user is calling OnePipe
            if (this.isCallingOnePipe) {
                PaymentSession.updateSessionFromForm('card');
            }
        }

    },

    mounted() {
        if (this.data.details.source && this.data.details.source == 'iframeReply') { // Coming from 3D Secure Page
            this.provider = this.data.details.iframereply.provider;
            this.redirect_returning_data = this.data.details.iframereply;
            this.validate3DS_Transaction(`${this.redirect_returning_data.redirect_content};${this.redirect_returning_data.data.response_gatewayRecommendation || ''};${this.redirect_returning_data.data.result || ''}`); // token or ession ID here..
            return;
        }

        if (this.data.details.action != null && this.data.details.action[0].provider != null) {
            this.provider = this.data.details.action[0];
            this.$store.dispatch('provider', this.provider);

            if (this.provider.provider.toLowerCase() == "mpgs") {
                this.loading = this.isMpgs = true;
                this.lookUpTokens();
            } else {
                this.isLoading = false;
                this.showCardInput = true;
            }
        }

    },
    data() {
        return {
            // provider:'',
            attemptCardRemoval: false,
            attemptCardRemovalCardKey: null,
            cardToBeRemoved: {},
            isVerve: false,
            isLoading: true,
            getPin: false,
            isCallingOnePipe: false,
            checkToken: false,
            ccBorderColor: '',
            isMpgs: false,
            mpgsIsReady: false,
            tokenize: false,
            showCardInput: false,
            session_id: '',
            token: '',
            mpgsSdkUrl: '',
            cards: [],

            provider: {},
            scriptLoaded: null,
            showToken: false,
            enforce_tokenization: false,
            loadingMessage: 'Loading.. please wait',
            errors: {
                card_cc: false,
                card_exp: false,
                card_exp_month: false,
                card_exp_year: false,
                card_cvv: false,
            },
            removalMessage: '',
            removalMessageStyle: {
                'color': '#3c763d',
                'background-color': '#dff0d8',
                'border-color': '#d6e9c6',
                'color': '#a94442',
                'background-color': '#f2dede',
                'border-color': '#ebccd1',
                'padding': '5px',
                'margin-bottom': '20px',
                'border': '1px solid transparent',
                'border-radius': '4px',
                'text-align': 'center',
            },
            iframe_html_content: '',
            redirectToThirdParty: false,
            initial_redirect_data: '',
            redirect_returning_data: '',
            countDownSeconds: 3,
        }
    },
    methods: {
        handleIsLoading(val) {
            this.loading = val
        },
        changePaymentOption() {
            this.$parent.changeComponent("PaymentOptions");
            if (window.countDown)
                clearInterval(window.countDown);
        },

        loadScript(callback) {
            let base_url = this.provider.extras.api_base_url,
                href = `${base_url}/form/version/${this.provider.extras.version || 57}/merchant/${this.provider.extras.merchant}/session.js`;
            this.mpgsSdkUrl = href;
            // console.log(href);

            let el = document.querySelector(`script[src='${href}']`);

            if (document.querySelector("script[src='" + href + "']")) {
                return;
            }
            const script = document.createElement('script');
            script.setAttribute('src', href);
            script.setAttribute('type', "text/javascript");
            document.head.appendChild(script);
            if (script.readyState) { // IE
                script.onreadystatechange = () => {
                    if (script.readyState === "loaded" || script.readyState === "complete") {
                        script.onreadystatechange = null;
                        callback();
                    }
                };
            } else { // Others
                script.onload = () => {
                    callback();
                };
            }
        },

        triggerCardInput() {
            this.showCardInput = true;
            this.scriptLoaded = new Promise(resolve => {
                this.loadScript(() => {
                    resolve();
                });
            });

            this.integration();
        },

        triggerPayment() {
            PaymentSession.updateSessionFromForm('card');
        },

        integration() {
            this.scriptLoaded && this.scriptLoaded.then(() => {

                let vm = this;
                vm.isLoading = false;

                PaymentSession.configure({
                    fields: {
                        // ATTACH HOSTED FIELDS TO YOUR PAYMENT PAGE FOR A CREDIT CARD
                        card: {
                            number: "#card_cc",
                            securityCode: "#card_cvv",
                            expiryMonth: "#card_exp_month",
                            expiryYear: "#card_exp_year"
                        }
                    },
                    //SPECIFY YOUR MITIGATION OPTION HERE
                    frameEmbeddingMitigation: ["javascript"],
                    callbacks: {
                        initialized: function (response) { // HANDLE INITIALIZATION RESPONSE
                            if (response.status == "ok") {
                                vm.isLoading = false;
                                vm.removeMargin = true;
                                vm.mpgsIsReady = true;

                                if (document.getElementById('mpgs-loading-message')) {
                                    document.getElementById('mpgs-loading-message').style.display = 'none';
                                    vm.mpgsIsReady = true;
                                }
                            }
                        },
                        formSessionUpdate: function (response) { // HANDLE RESPONSE FOR UPDATE SESSION

                            if (response.status) {
                                if ("ok" == response.status) {
                                    vm.callOnePipe(response.session.id);
                                } else if ("fields_in_error" == response.status) {

                                    vm.isLoading = false;

                                    if (response.errors.cardNumber) {
                                        vm.errors.card_cc = true
                                    }
                                    if (response.errors.expiryYear) {
                                        vm.errors.card_exp_year = true
                                    }
                                    if (response.errors.expiryMonth) {
                                        vm.errors.card_exp_month = true
                                    }
                                    if (response.errors.securityCode) {
                                        vm.errors.card_cvv = true;
                                    }

                                } else if ("request_timeout" == response.status) {
                                    alert("Session update failed with request timeout: " + response.errors.message);
                                } else if ("system_error" == response.status) {
                                    alert("Session update failed with system error: " + response.errors.message);
                                }
                            } else {
                                alert("Session update failed: " + response);
                            }
                        }
                    }
                });
            });
        },

        updatedIntegration() {
            this.scriptLoaded && this.scriptLoaded.then(() => {

                let vm = this;

                PaymentSession.configure({
                    // window.PaymentSession.configure({
                    fields: {
                        // ATTACH HOSTED FIELDS TO YOUR PAYMENT PAGE FOR A CREDIT CARD
                        card: {
                            number: "#card_cc",
                            securityCode: "#card_cvv",
                            expiryMonth: "#card_exp_month",
                            expiryYear: "#card_exp_year"
                        }
                    },
                    //SPECIFY YOUR MITIGATION OPTION HERE
                    frameEmbeddingMitigation: ["javascript"],
                    callbacks: {
                        initialized: function (response) { // HANDLE INITIALIZATION RESPONSE
                            if (response.status == "ok") {
                                vm.isLoading = false;
                                vm.removeMargin = true;
                                vm.mpgsIsReady = true;

                                if (document.getElementById('mpgs-loading-message')) {
                                    document.getElementById('mpgs-loading-message').style.display = 'none';
                                    vm.mpgsIsReady = true;
                                }
                            }
                        },
                        formSessionUpdate: function (response) { // HANDLE RESPONSE FOR UPDATE SESSION
                            if (response.status) {
                                if ("ok" == response.status) {
                                    vm.callOnePipe(response.session.id);
                                } else if ("fields_in_error" == response.status) {

                                    vm.isLoading = false;

                                    if (response.errors.cardNumber) {
                                        vm.errors.card_cc = true
                                    }
                                    if (response.errors.expiryYear) {
                                        vm.errors.card_exp_year = true
                                    }
                                    if (response.errors.expiryMonth) {
                                        vm.errors.card_exp_month = true
                                    }
                                    if (response.errors.securityCode) {
                                        vm.errors.card_cvv = true;
                                    }

                                } else if ("request_timeout" == response.status) {
                                    alert("Session update failed with request timeout: " + response.errors.message);
                                } else if ("system_error" == response.status) {
                                    alert("Session update failed with system error: " + response.errors.message);
                                }
                            } else {
                                alert("Session update failed: " + response);
                            }
                        }
                    }
                });
            });
        },

        callOnePipe(session) {
            this.isLoading = true;

            if (Object.keys(this.provider.extras).includes('enable_3dsecure') && this.provider.extras.enable_3dsecure != null && this.provider.extras.enable_3dsecure.toLowerCase() === 'true') {
                this.loadingMessage = 'Initializing Payment...';
            } else {
                this.loadingMessage = 'Making Payment...';
            }

            /* 
                This is an hack to get value of the tokenized checked box
                I didn't use v-model becuase, it usually unmount the mounted Mastercard Payment field
            */

            if (session == "" && session.length < 0) {
                // Can't call OnePipe show error
                this.errors.card_cc = "Fill card details correctly";
                this.isCallingOnePipe = this.isLoading = false;
                this.loadingMessage = '';

                return
            }

            if (document.getElementById('tokenize-card')) {
                let elem = document.getElementById('tokenize-card');
                if (elem.checked)
                    this.tokenize = true;
                else
                    this.tokenize = false;
            }

            // if enforce tokenize is true
            if (this.enforce_tokenization && this.showCardInput) {
                this.tokenize = true;
            }

            try {
                let initialPayload = this.$store.state.payload;

                let payload = {
                    request_ref: initialPayload.request_ref,
                    request_type: initialPayload.request_type,
                    auth: {
                        "type": "custom",
                        "secure": session,
                        "auth_provider": "MPGS",
                    },
                    transaction: initialPayload.transaction
                }

                // Check if the transaction.details is available 
                if (Object.keys(payload.transaction).includes('details') && payload.transaction.details != null) {
                    payload.transaction.details.tokenize = this.tokenize;
                } else {
                    payload.transaction.details = {
                        tokenize: this.tokenize
                    }
                }

                // check if the user is trying again, update the transaction ref
                payload.transaction.transaction_ref = this.$store.state.transRef
                if (this.$store.state.isFailed)
                    payload.transaction.transaction_ref_parent = this.$store.state.parentTransRef

                let data2 = {
                    api_key: this.$store.state.api_key,
                    endpoint: 'transact',
                    payload: payload
                }
                let data = this.$generateToken(data2);

                axios.post(this.baseApiUrl + "v2/onepipe/js", {
                    data,
                }, {
                    timeout: this.API_CALL_TIMEOUT, // 3 mins
                    headers: {
                        Authorization: 'bearer ' + this.$store.state.payload.api_key
                    }
                }).then((response) => {
                    this.isLoading = false;
                    this.loadingMessage = 'Loading.. please wait';
                    let hash = response.data.data,
                        res = this.$decodeToken(hash),
                        status = res.status.toLowerCase(),
                        message = res.message,
                        responseData = res.data;

                    window.raw = JSON.stringify(res);

                    // Go and do the auto close popup on the status page instead of every pages.. it's more descent that way
                    if (status == "successful") {

                        this.isLoading = false;
                        this.$parent.changeComponent('Status', {
                            reference: payload.transaction.transaction_ref,
                            type: 'Successful',
                            data: responseData,
                            message: message || res.data.message
                        });

                    } else if (status === "pendingvalidation") {

                        this.isLoading = false;
                        this.iframe_html_content = responseData.provider_response.html_content;
                        this.redirectToThirdParty = true;
                        this.initial_redirect_data = {
                            'status': 'redirect',
                            'data': {
                                'transaction': this.transaction,
                                'redirectUrl': window.location.hostname === 'localhost' ?
                                    'http://redirect.md/' : this.provider.custom_ui_url,
                                "callback_url": window.location.hostname === 'localhost' ?
                                    'http://redirect.md/' : this.provider.extras.callback_url,
                                'chargeUrl': data.iframeUrl,
                                'sourceUrl': window.location.hostname === 'localhost' ?
                                    'http://onepipejs.md/inline-v2.min.js' : 'https://js.dev.onepipe.io/v2', //window.parent.location.href,
                                'provider': this.provider,
                                'iframe_html_content': this.iframe_html_content,
                                'redirect_type': responseData.provider_response.redirect_type,
                                'redirect_content': responseData.provider_response.redirect_content,
                            }
                        }

                        // start countdown in 5 secs
                        setTimeout(() => {
                            this.timeoutCountdown();
                        }, 1000);

                    } else {
                        window.failedFromStart = false;
                        window.failedFromStartMessage = message || "Payment Failed."
                        this.$router.push('/v2/warning');
                    }
                }).catch(err => {
                    console.log(err)
                    window.raw = JSON.stringify(err);
                    window.failedFromStart = false;
                    window.failedFromStartMessage = err;
                    this.$router.push('/v2/warning');
                })
            } catch (err) {
                console.log(`Call OnePipe Error ${err}`)
                window.raw = JSON.stringify(err);
                window.failedFromStart = false;
                window.failedFromStartMessage = err;
                this.$router.push('/v2/warning');
            }
        },

        lookUpTokens() {
            try {
                let initialPayload = this.$store.state.payload,
                    payload = {
                        request_ref: this.$generateRequestRef(),
                        request_type: 'lookup_cards',
                        auth: {
                            "type": "custom",
                            "secure": initialPayload.transaction.customer.customer_ref,
                            "auth_provider": "MPGS",
                        },
                        transaction: {
                            transaction_ref: this.$generateTransactionRef(),
                            transaction_ref_parent: "",
                            customer: initialPayload.transaction.customer
                        }
                    },
                    data2 = {
                        api_key: this.$store.state.api_key,
                        endpoint: 'transact',
                        payload: payload
                    },
                    dataPayload = this.$generateToken(data2);

                axios.post(this.baseApiUrl + "v2/onepipe/js", {
                    data : dataPayload,
                }, {
                    timeout: this.API_CALL_TIMEOUT, // 3 mins
                    headers: {
                        Authorization: `Bearer ${this.$store.state.payload.api_key}`
                    }
                }).then(({
                    data
                }) => {
                    this.isLoading = false;
                    this.loadingMessage = 'Loading.. please wait';
                    let hash = data.data,
                        res = this.$decodeToken(hash),
                        status = res.status.toLowerCase(),
                        responseData = res.data;

                    window.raw = JSON.stringify(res);

                    this.showCardInput = true;

                    if (status == "successful" && Object.keys(responseData.provider_response).includes('cards') && responseData.provider_response.cards.length > 0) {
                        this.showCardInput = false;
                        this.cards = responseData.provider_response.cards;
                        return ;
                    }

                    this.showCardInput = true;
                    setTimeout(() => {
                        this.triggerCardInput();
                    }, 1000);

                }).catch(err => {
                    console.log(err)
                    window.raw = JSON.stringify(err);
                    window.failedFromStart = false;
                    window.failedFromStartMessage = err;
                    this.$router.push('/v2/warning');
                })
            } catch (err) {
                console.log(`Call OnePipe Error ${err}`)
                window.raw = JSON.stringify(err);
                window.failedFromStart = false;
                window.failedFromStartMessage = err;
                this.$router.push('/v2/warning');
            }
        },

        handleAttemptCardRemoval(key) {
            this.attemptCardRemoval = true,
                this.attemptCardRemovalCardKey = key,
                this.cardToBeRemoved = this.cards[key];
        },
        cancelCardRemoval() {
            this.attemptCardRemoval = false,
                this.attemptCardRemovalCardKey = null,
                this.cardToBeRemoved = {};
        },

        removeCard() {
            let token = this.cardToBeRemoved;

            try {

                let initialPayload = this.$store.state.payload;
                this.isLoading = true;

                let payload = {
                    request_ref: this.$generateRequestRef(),
                    request_type: 'remove card',
                    auth: {
                        "type": "custom",
                        "secure": token.uid,
                        "auth_provider": "MPGS",
                    },
                    transaction: {
                        transaction_ref: this.$generateTransactionRef(),
                        transaction_ref_parent: "",
                        customer: initialPayload.transaction.customer
                    }
                }

                let data2 = {
                    api_key: this.$store.state.api_key,
                    endpoint: 'transact',
                    payload: payload
                }
                let data = this.$generateToken(data2);

                axios.post(this.baseApiUrl + "v2/onepipe/js", {
                    data,
                }, {
                    timeout: this.API_CALL_TIMEOUT, // 3 mins
                    headers: {
                        Authorization: 'bearer ' + this.$store.state.payload.api_key
                    }
                }).then((response) => {
                    this.isLoading = false;
                    this.loadingMessage = 'Loading.. please wait';
                    let hash = response.data.data,
                        res = this.$decodeToken(hash),
                        status = res.status.toLowerCase(),
                        message = res.message,
                        responseData = res.data;

                    window.raw = JSON.stringify(res);

                    if (response.status == 200) {

                        this.isLoading = false;
                        if (status == "successful") {

                            // Successful style
                            this.removalMessageStyle = {
                                'color': '#3c763d',
                                'background-color': '#dff0d8',
                                'border-color': '#d6e9c6',
                                'padding': '5px',
                                'margin-bottom': '20px',
                                'border': '1px solid transparent',
                                'border-radius': '4px',
                                'text-align': 'center',
                            }

                            const key = this.cards.indexOf(this.cardToBeRemoved);
                            this.cards.splice(key, 1);
                            this.removalMessage = message;

                            if (this.cards.length <= 0) {
                                this.removalMessage = '';
                                this.showCardInput = true;
                                setTimeout(() => {
                                    this.loading = false;
                                    this.triggerCardInput();
                                    this.integration();
                                }, 1000);
                            } else {
                                setTimeout(() => {
                                    this.removalMessage = '';
                                }, 2000);
                            }

                        } else {
                            this.removalMessage = message;
                            setTimeout(() => {
                                this.removalMessage = '';
                            }, 2000);

                        }
                    } else {
                        this.removalMessage = message;
                        setTimeout(() => {
                            this.removalMessage = '';
                        }, 3000);
                    }

                }).catch(err => {
                    this.removalMessage = err;
                    console.log(err)
                    window.raw = JSON.stringify(err);
                    window.failedFromStart = false;
                    window.failedFromStartMessage = err;
                    this.$router.push('/v2/warning');
                })
            } catch (err) {
                console.log(`Call OnePipe Error ${err}`)
                window.raw = JSON.stringify(err);
                window.failedFromStart = false;
                window.failedFromStartMessage = err;
                this.$router.push('/v2/warning');
            }

        },

        visitThirdParty() { // Redirect to other screens
            this.isLoading = true;
            setTimeout(() => {
                this.$parent.componentId = "";
                window.parent.postMessage(JSON.stringify(this.initial_redirect_data), '*');
            }, 300);
        },

        cancelRedirect() {
            // Generate a new ref
            const newRef = `${this.$store.state.parentTransRef}-${this.$generateTransactionRef()}`;
            this.$store.dispatch('transRef', newRef);
            this.$store.dispatch('isFailed', true);
            this.redirectToThirdParty = false;

            let el = document.querySelector(`script[src='${this.mpgsSdkUrl}']`);
            if (el) {
                el.remove();
            }

            clearInterval(window.countDown);

        },

        validate3DS_Transaction(ref) {

            this.isLoading = true;

            this.loadingMessage = 'Making Payment...';

            // let initialPayload = this.getInitialPayload(),
            let payload = {
                request_ref: this.$generateRequestRef(),
                request_type: this.$store.state.payload.request_type,
                auth: {
                    secure: ref, // Token,SESSIONid
                    auth_provider: this.provider.provider
                },
                transaction: {
                    transaction_ref: this.$store.state.transRef
                }
            };

            if (this.$store.state.isFailed) {
                payload.transaction.transaction_ref_parent = this.$store.state.parentTransRef
            }

            payload.transaction.transaction_ref = this.$store.state.transRef

            let data2 = {
                    endpoint: 'validate',
                    api_key: this.$store.state.api_key,
                    payload,
                },
                data = this.$generateToken(data2);

            // console.log(JSON.stringify(data2));
            axios.post(this.baseApiUrl + "v2/onepipe/js", {
                    data,
                }, {
                    timeout: this.API_CALL_TIMEOUT, // 3 mins
                    headers: {
                        Authorization: 'bearer ' + this.$store.state.payload.api_key
                    }
                }).then(response => {

                    let hash = response.data.data,
                        res = this.$decodeToken(hash),
                        status = res.status.toLowerCase(),
                        message = res.message,
                        responseData = res.data;

                    window.raw = JSON.stringify(res);

                    if (status === "successful") {
                        this.isLoading = false;
                        this.$parent.changeComponent('Status', {
                            reference: payload.transaction.transaction_ref,
                            type: 'Successful',
                            data: responseData,
                            message: message || res.data.message
                        });

                    } else {
                        window.failedFromStart = false;
                        window.failedFromStartMessage = message || "Payment Failed."
                        this.$router.push('/v2/warning');
                    }

                })
                .catch(error => {
                    console.log(error)
                    window.failedFromStartMessage = error;
                    window.failedFromStart = false;
                    this.$router.push('/v2/warning');
                })

        },

        timeoutCountdown() {
            window.countDown = setInterval(() => {
                this.countDownSeconds--
                if (this.countDownSeconds <= 0) {
                    clearInterval(window.countDown);
                    this.visitThirdParty();
                    return;
                }
            }, 1000);

        },

        queryMpgsTransaction(ref) {

            this.isLoading = true;

            this.loadingMessage = 'Making Payment...';

            // let initialPayload = this.getInitialPayload(),
            let payload = {
                request_ref: this.$generateRequestRef(),
                request_type: this.$store.state.payload.request_type,
                auth: {
                    // secure: ref, // Token,SESSIONid
                    auth_provider: this.provider.provider
                },
                transaction: {
                    transaction_ref: this.$store.state.transRef
                }
            };

            if (this.$store.state.isFailed) {
                payload.transaction.transaction_ref_parent = this.$store.state.parentTransRef
            }

            payload.transaction.transaction_ref = this.$store.state.transRef

            let data2 = {
                    endpoint: 'query',
                    api_key: this.$store.state.api_key,
                    payload,
                },
                data = this.$generateToken(data2);

            // console.log(JSON.stringify(data2));
            axios.post(this.baseApiUrl + "v2/onepipe/js", {
                    data,
                }, {
                    timeout: this.API_CALL_TIMEOUT, // 3 mins
                    headers: {
                        Authorization: 'bearer ' + this.$store.state.payload.api_key
                    }
                }).then(response => {

                    let hash = response.data.data,
                        res = this.$decodeToken(hash),
                        status = res.status.toLowerCase(),
                        message = res.message,
                        responseData = res.data;

                    window.raw = JSON.stringify(res);

                    if (status === "successful") {
                        this.isLoading = false;
                        this.$parent.changeComponent('Status', {
                            reference: payload.transaction.transaction_ref,
                            type: 'Successful',
                            data: responseData,
                            message: message || res.data.message
                        });

                    } else {
                        window.failedFromStart = false;
                        window.failedFromStartMessage = message || "Payment Failed."
                        this.$router.push('/v2/warning');
                    }

                })
                .catch(error => {
                    console.log(error)
                    window.failedFromStartMessage = error;
                    window.failedFromStart = false;
                    this.$router.push('/v2/warning');
                })

        },

    }
}
</script>
